// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--3JqqI","sticky":"index-module--sticky--1SoHO"};